import { File } from '../file';
import { JobSearchExperienceLevel } from '../intern/job-search-experience-level';
import { ContentIntro } from './intro';
import { ContentArticleText } from './section';

/**
 * Model definition for info
 */
export interface ContentJobSearch {
  __component: 'content.job-search';
  id: string;
  intro?: ContentIntro;
  showJobAgent?: boolean;
  showCompanyFilter?: boolean;
  jobAgentImage?: File;
  experienceLevels?: Array<JobSearchExperienceLevel>;
  jobAgentDisclaimer?: ContentArticleText;
}

export function isContentJobSearch(obj: { __component?: string }): obj is ContentJobSearch {
  return obj.__component === 'content.job-search';
}
